import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';

import BREADCRUMB_ARROW from '../../images/icons/breadcrumb_caret.svg';
import HOME_ICON from '../../images/icons/house.svg';

import categoryLocalization from '../../locales/en/category.json';
import { CATEGORY_HIERARCHY } from '../../utils/constants/category';
import Link from '../Link';
import { useStyles } from './styles';
import { setBreadcrumbForAdob } from '../../utils/analytics/adobe/adob';
import { URL } from '../../utils/constants/general';
import DropdownMenu from './DropdownMenu';
import { setBreadcrumbForLocal } from '../../utils/analytics/local';

const Breadcrumbs = () => {
	const { t } = useTranslation(['category', 'main']);
	const classes = useStyles();
	const [breadcrumbs, setBreadcrumbs] = useState([]);
	const history = useHistory();
	const location = useLocation();
	const params = useParams();

	useEffect(() => {
		function createLabel(categoryId) {
			const title = t('category:' + categoryId + '.title');
			const abbreviation = categoryLocalization[categoryId].abbreviation;

			return abbreviation ? t('category:' + categoryId + '.abbreviation') + ' - ' + title : title;
		}

		let path = '';
		let category = CATEGORY_HIERARCHY;
		const newBreadcrumbs = [];

		for (const [, value] of Object.entries(params)) {
			if (value === undefined) break;

			try {
				category = category.categories.find(cat => cat.pathParam === value);
				path += '/' + value;

				newBreadcrumbs.push({
					path: path,
					label: createLabel(category.id)
				});
			} catch (error) {
				break;
			}
		}

		if (location.pathname.includes('/wdValidated')) {
			newBreadcrumbs.push({
				path: location.pathname,
				label: 'WD+ Validated'
			});
		}

		if (location.pathname === '/') {
			newBreadcrumbs.push({
				path: location.pathname,
				label: 'Landing Page'
			});
		}

		setBreadcrumbs(newBreadcrumbs);
		setBreadcrumbForAdob(newBreadcrumbs);
		setBreadcrumbForLocal(newBreadcrumbs);
	}, [location.pathname, params, t]);

	const handleClick = path => event => {
		event.preventDefault();
		history.push(path);
	};

	return (
		<MuiBreadcrumbs
			separator={<img src={BREADCRUMB_ARROW} width="12" height="12" alt={'breadcrumb arrow'} />}
			aria-label="breadcrumbs"
			className={classes.breadcrumbs}>
			<Link href={URL.ONSEMI} tabIndex={0}>
				<img src={HOME_ICON} width="16" height="16" alt={'house icon'} />
			</Link>

			<Link href={URL.DESIGN_PAGE} tabIndex={0}>
				<Typography variant="body1">{t('main:components.breadcrumbs.design')}</Typography>
			</Link>

			<Typography variant="body1">{t('main:components.breadcrumbs.tools&eva')}</Typography>

			{location.pathname === '/' ? (
				<DropdownMenu sx={{ height: 21 }} />
			) : (
				<Link onClick={handleClick('/')} tabIndex={0} aria-label="Home">
					<Typography variant="body1">{t('main:components.breadcrumbs.prt')}</Typography>
				</Link>
			)}

			{location.pathname === '/' ? null : (
				<>
					{breadcrumbs.map((br, index) =>
						index < breadcrumbs.length - 1 ? (
							<Link key={br.path + '-breadcrumbs-link'} color="textSecondary" onClick={handleClick(br.path)}>
								{br.label}
							</Link>
						) : (
							<Typography key={br.path + '-breadcrumbs-link'} color="textPrimary">
								{br.label}
							</Typography>
						)
					)}
				</>
			)}
		</MuiBreadcrumbs>
	);
};

export default Breadcrumbs;
